"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useWeb3_1 = require("../hooks/useWeb3");
var Manager = function (_a) {
    var children = _a.children, error = _a.error, injectedConnector = _a.injectedConnector, networkConnector = _a.networkConnector, autoConnect = _a.autoConnect;
    var active = (0, useWeb3_1.useUserWeb3)().active;
    var _b = (0, useWeb3_1.useNetworkWeb3)(), networkActive = _b.active, networkError = _b.error, activateNetwork = _b.activate;
    // try to eagerly connect to an injected provider, if it exists and has granted access already
    var triedEager = (0, useWeb3_1.useEagerConnect)(injectedConnector, autoConnect);
    // after eagerly trying injected, if the network connect ever isn't active or in an error state, activate itd
    (0, react_1.useEffect)(function () {
        if (networkConnector &&
            triedEager &&
            !networkActive &&
            !networkError &&
            !active) {
            activateNetwork(networkConnector);
        }
    }, [
        triedEager,
        networkActive,
        networkError,
        activateNetwork,
        active,
        networkConnector
    ]);
    // fix change network to avalanche
    (0, react_1.useEffect)(function () {
        if (window.ethereum && window.ethereum.removeAllListeners) {
            window.ethereum.removeAllListeners(['networkChanged']);
        }
    }, []);
    // when there's no account connected, react to logins (broadly speaking) on the injected provider, if it exists
    (0, useWeb3_1.useInactiveListener)(injectedConnector, !triedEager);
    // if the account context isn't active, and there's an error on the network context, it's an irrecoverable error
    if (triedEager && !active && networkError) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: error }, void 0);
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }, void 0);
};
exports.default = Manager;
